/** Tab "Phổ biến" (`EsimHubTabs`) — hardcode vì `extra.popular_countries` từ `/esim/countries` hiện trả
 * mảng rỗng (BE có field nhưng chưa có data, xem docs/planBuild/plan_improve.md). Tên/mô tả hiển thị
 * resolve động từ `useEsimCountriesData`/`useEsimGoodPriceCountry`, ở đây chỉ giữ mã ISO alpha-2. */
export const ESIM_POPULAR_COUNTRY_CODES = [
  "cn",
  "hk",
  "th",
  "sg",
  "my",
  "id",
  "ph",
  "jp",
  "kr",
  "tw",
  "in",
  "us",
  "ca",
  "au",
  "nz",
  "fr",
] as const;
